/**
 * RoutineVaccinationSection — full table → form → summary orchestrator
 * for profile / linked-child previous vaccination (not session drawer).
 */

import React, { useState, useEffect } from 'react';
import RoutineMemberVaccination from './RoutineMemberVaccination';
import VaccinationSummary from './Vaccinationsummary';
import {
  buildRoutineBeneficiaryData,
  getRoutineBeneficiaryType,
} from './routineVaccinationHelpers';

const RoutineVaccinationTable = ({
  vaccinationDetails = [],
  onUpdatePreviousVaccination,
}) => (
  <div style={{ width: '100%' }}>
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        marginBottom: '12px',
      }}
    >
      <button
        type="button"
        className="sickle-save-button"
        onClick={onUpdatePreviousVaccination}
      >
        Update Previous Vaccination
      </button>
    </div>
    <div className="medicationTable routine-vaccine" style={{ marginTop: 0 }}>
      <div className="tableRows mb-3">
        <div className="table-responsive">
          <table className="table table-bordered chiled-data custom-striped">
            <thead>
              <tr>
                <th>Age</th>
                <th>Vaccine Name</th>
                <th>Due Date</th>
                <th>Vaccination Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {vaccinationDetails?.length > 0 ? (
                vaccinationDetails.map((vaccine, index) => (
                  <tr key={index}>
                    <td>{vaccine.displayAge}</td>
                    <td>{vaccine.display_dose_name}</td>
                    <td>{vaccine.due_date}</td>
                    <td>{vaccine.vaccination_date}</td>
                    <td>{vaccine.msg}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No vaccination data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

const RoutineVaccinationSection = ({
  beneficiaryRow,
  beneficiaryType: beneficiaryTypeProp,
  sessionSiteId,
  vaccinationDetails,
  onVaccinationSaved,
}) => {
  const [viewState, setViewState] = useState('table');
  const [formData, setFormData] = useState(null);
  const [chartDetails, setChartDetails] = useState([]);

  useEffect(() => {
    if (Array.isArray(vaccinationDetails) && vaccinationDetails.length > 0) {
      setChartDetails(vaccinationDetails);
    }
  }, [vaccinationDetails]);

  const beneficiaryData = buildRoutineBeneficiaryData(beneficiaryRow, {
    sessionSiteId,
  });
  const beneficiaryType = getRoutineBeneficiaryType(
    beneficiaryRow,
    beneficiaryTypeProp
  );

  const handleOpenForm = () => {
    if (Array.isArray(vaccinationDetails) && vaccinationDetails.length > 0) {
      setChartDetails(vaccinationDetails);
    }
    setViewState('form');
  };

  const handleFormSuccess = (completedFormData) => {
    setFormData(completedFormData);
    setViewState('summary');
  };

  const handleBackToForm = () => {
    setViewState('form');
  };

  const handleCancel = () => {
    setViewState('table');
    setFormData(null);
  };

  const handleComplete = async () => {
    setFormData(null);
    setViewState('table');
    if (onVaccinationSaved) {
      await onVaccinationSaved();
    }
  };

  if (viewState === 'form') {
    return (
      <RoutineMemberVaccination
        beneficiaryData={beneficiaryData}
        beneficiaryType={beneficiaryType}
        onFormComplete={handleFormSuccess}
        toggleDrawer={() => () => handleCancel()}
        isStepperMode={true}
      />
    );
  }

  if (viewState === 'summary' && formData) {
    return (
      <VaccinationSummary
        vaccinationData={formData}
        beneficiaryData={beneficiaryData}
        onComplete={handleComplete}
        onCancel={handleBackToForm}
      />
    );
  }

  return (
    <RoutineVaccinationTable
      vaccinationDetails={chartDetails}
      onUpdatePreviousVaccination={handleOpenForm}
    />
  );
};

export default RoutineVaccinationSection;
